<template>
  <div :class="['head-content', isSearch ? 'gray' : '']">
    <div v-if="isShowBack" @click="goBack" class="back">
      <img src="../../assets/image/home/back-icon.png" alt="">
    </div>
    <div class="mian">
      <img v-if="!isShowBack" src="../../assets/image/home/logo.png" alt="">
      <div v-else class="name">{{ name }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      // isSearch: false
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      },
    }),
    name () {
      return this.$route.meta.title
    },
    isShowBack () {
      return this.$route.path !== '/home'
    },
    isSearch () {
      return this.$route.name === 'Search'
    }
  },
  mounted () {

  },
  methods: {
    // 返回上一层
    goBack () {
      if (this.$route.name === 'SuccessOrder') {
        this.$router.push({ path: '/home' })
      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 980px) {
  .head-content {
    width: 100%;
    height: 88px;
    // position: relative;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 999;
    .mian {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .name {
        text-align: center;
        line-height: 88px;
        font-size: 32px;
        color: #333;
        font-weight: 500;
      }
      img {
        width: 141px;
        height: 36px;
      }
    }
    .back {
      width: 48px;
      height: 48px;
      position: absolute;
      top: 20px;
      left: 24px;
      img {
        width: 100%;
      }
    }
  }
  .gray {
    background: #F7F7F7!important;
  }
}
@media (min-width: 981px) {
  .head-content {
    background: #fff;
    height: 80px!important;
  }
  .head-box{
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    background: #fff;
  }
  .head {
    width: 1200px!important;
    height: 80px!important;
    width: 100%;
    line-height: 80px;
    background: #fff;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      width: 160px;
      height: 48px;
    }
  }

  .tabs {
    display: flex;
    margin-right: 24px;
  }

  .tab {
    // padding: 0 24px;
    width: 160px;
    cursor: pointer;
    position: relative;
    color: #333;
    font-family: "PingFang SC";
  }

  .tab.active{
    font-weight: bold;
    color: #111;
  }

  .tab.active::after {
      content: '';
      position: absolute;
      bottom: 15px;
      left: 50%;
      width: 30px;
      margin-left: -15px;
      height: 4px;
      border-radius: 2px;
      background: #405FFF;
  }
}
</style>
